import { render, staticRenderFns } from "./ReClientCallList.vue?vue&type=template&id=62dc8d71&scoped=true"
import script from "./ReClientCallList.vue?vue&type=script&lang=js"
export * from "./ReClientCallList.vue?vue&type=script&lang=js"
import style0 from "./ReClientCallList.vue?vue&type=style&index=0&id=62dc8d71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dc8d71",
  null
  
)

export default component.exports